// extracted by mini-css-extract-plugin
module.exports = {"header":"FilterMenuHeader__header--XXYNq","filterContainer":"FilterMenuHeader__filterContainer--2nBKc","alignBox":"FilterMenuHeader__alignBox--v9-dy"};